import { API } from "@infra/api";
import { makeDuplicateDealsUseCases } from "@app/deals";
import type { Deal } from "@domain/CRM/deal";
import type { IDeals } from "@ports/deals/IDeals";

const dealsApi: IDeals = {
	getByFilter: (filter) => API.Data.Deals.get.byFilter(filter) as Promise<Deal[]>,
	getByCompany: (company) => API.Data.Deals.get.byCompany(company) as Promise<Deal[]>,
	getByIds: (ids) => API.Data.Deals.get.byIds(ids) as Promise<Deal[]>,
	createMany: (deals) => API.Data.Deals.create.many(deals as Deal[]) as Promise<Deal[]>,
	createOne: (deal) => API.Data.Deals.create.one(deal as Deal) as Promise<Deal>,
};

export const duplicateDealsUseCases = makeDuplicateDealsUseCases({ dealsApi });
